function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * CanvasWorld
 */
var CanvasWorld =
/*#__PURE__*/
function () {
  /**
   * @param {Array} canvases - Array of Manifesto:Canvas objects to create a
   * world from.
   */
  function CanvasWorld(canvases) {
    var viewingDirection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'left-to-right';

    _classCallCheck(this, CanvasWorld);

    this.canvases = canvases;
    this.viewingDirection = viewingDirection;
  }
  /** */


  _createClass(CanvasWorld, [{
    key: "canvasToWorldCoordinates",

    /**
     * canvasToWorldCoordinates - calculates the canvas coordinates respective to
     * the world.
     */
    value: function canvasToWorldCoordinates(i) {
      var wholeBounds = this.worldBounds();
      var canvas = this.canvases[i];
      var aspectRatio = canvas.getWidth() / canvas.getHeight();
      var scaledWidth = Math.floor(wholeBounds[3] * aspectRatio);
      var x = 0;

      if (i === this.secondCanvasIndex) {
        x = wholeBounds[2] - scaledWidth;
      }

      return [x, 0, scaledWidth, wholeBounds[3]];
    }
    /**
     * secondCanvasIndex - index of the second canvas used for determining which
     * is first
     */

  }, {
    key: "indexOfTarget",

    /** */
    value: function indexOfTarget(canvasTarget) {
      return this.canvases.map(function (canvas) {
        return canvas.id;
      }).indexOf(canvasTarget);
    }
    /**
     * offsetByCanvas - calculates the offset for a given canvas target. Currently
     * assumes a horrizontal only layout.
     */

  }, {
    key: "offsetByCanvas",
    value: function offsetByCanvas(canvasTarget) {
      var offset = {
        x: 0,
        y: 0
      };
      var i;

      for (i = 0; i < this.indexOfTarget(canvasTarget); i += 1) {
        offset.x += this.canvases[i].getWidth();
      }

      return offset;
    }
    /**
     * worldBounds - calculates the "World" bounds. World in this case is canvases
     * lined up horizontally starting from left to right.
     */

  }, {
    key: "worldBounds",
    value: function worldBounds() {
      var heights = [];
      var dimensions = [];
      this.canvases.forEach(function (canvas) {
        heights.push(canvas.getHeight());
        dimensions.push({
          height: canvas.getHeight(),
          width: canvas.getWidth()
        });
      });
      var minHeight = Math.min.apply(Math, heights);
      var scaledWidth = 0;
      dimensions.forEach(function (dim) {
        var aspectRatio = dim.width / dim.height;
        scaledWidth += Math.floor(minHeight * aspectRatio);
      });
      return [0, 0, scaledWidth, minHeight];
    }
  }, {
    key: "canvasIds",
    get: function get() {
      return this.canvases.map(function (canvas) {
        return canvas.id;
      });
    }
  }, {
    key: "secondCanvasIndex",
    get: function get() {
      return this.viewingDirection === 'right-to-left' ? 0 : 1;
    }
  }]);

  return CanvasWorld;
}();

export { CanvasWorld as default };